import React from 'react';
import './SponsorsPage.css';

import { Heading, PageTitle } from '../../../components';
import { sponsors } from '../../../constants';



const SponsorsPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Sponsors'} page={'Sponsors'} />

      <section className='sponsors'>

        {/* Section heading */}
        <Heading title={'Our Sponsors'} subTitle={'Trusted Alliances'} />

        <div className='box-container'>

          {/* Loop through the sponsors array to display each sponsor's logo */}
          {sponsors.map((sponsor, index) => {
              return (
                <div className='sponsor-item' key={index}>
                  {/* Render the sponsor logo */}
                  <img src={sponsor} alt='Sponsor Logo' />
                </div>
              );
            })
          }

        </div>

      </section>

    </>
  );
}

export default SponsorsPage;